import { Injectable } from '@angular/core';
import { FormFieldConfig } from '../../../types/form-field-config';
import { FormBuilder } from '@angular/forms';
import { FormBuild } from './form-build';
import { AnyObject } from '@mri/types';

@Injectable({
  providedIn: 'root'
})
export class FormBuilderService {

  constructor(
    private _formBuilder: FormBuilder
  ) {
  }

  build<T = AnyObject>(configs: FormFieldConfig[]): FormBuild {
    const groupObject: Record<string, string> = {};
    configs.forEach(config => {
      const keys = (config.key ? [config.key]: config.keys)?.filter( k => !!k);
      keys?.forEach(key => {
        groupObject[key] = config.fillDefaultValue?.toString() || '';
      })
    });

    const form = this._formBuilder.group(groupObject);
    return new FormBuild<T>(form, configs);
  }
}
